// extracted by mini-css-extract-plugin
module.exports = {"root":"QuoteBar_root__6eEG4","QuoteBarText":"QuoteBar_QuoteBarText__3gVxK","QuoteBarAuthor":"QuoteBar_QuoteBarAuthor__hE_yY","icon":"QuoteBar_icon__iJ98U"};